import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
  },
});

function Container({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  const styles = useStyles();
  return (
    <div className={classNames(styles.container, className)}>{children}</div>
  );
}

export default Container;
